(function () {
	'use strict';
	var $ = require('jquery');

	// Add additional JS in separate include files and require them with relative paths
	// require('../../node_modules/lettering.js');
	// require('../../node_modules/textillate/jquery.textillate.js');
	require('../../node_modules/slick-carousel/slick/slick.js');
	require('@lottiefiles/lottie-player');
	require('./lottie-carousel.js');
	require('./lottie-tabs.js');
	require('./filter-behavior.js');
	require('./hsform-behavior.js');
	require('./newsletter-subscribe-form.js');
	require('./dashboard-form-behavior.js');
	require('./pricing-box.js');
	require('./misc.js');
	require('./term-filter.js');
	require('./lax-anims.js');
	require('./lottie-animations.js');
	require('./dashboard-signup.js');
	require('./position-location-filter');
	require('./footer-hamburger');

	$(document).ready(function () {
		$('.vc-terms__button').removeAttr('href').click(function () {
			$(this).parents('.vc-terms').find('.vc-terms__content').addClass('js-active').slideToggle();
		});

		//lp Opportunity Header stuff
		var lp_header = $('.lp-header');
		$(window).on('scroll', function () {
			var scroll = $(window).scrollTop();

			if (scroll >= 50) {
				lp_header.addClass('lp-header--dark');
			} else {
				lp_header.removeClass('lp-header--dark');
			}
		});

		//Industry selector cards
		$('.c-industry-selector__card').on('mouseenter', function () {
			$(this).addClass('is-open');
			$(this).find('.c-industry-selector__title').animate({
				top: '-254px'
			}, 250);

			$(this).find('.c-industry-selector__content').animate({
				top: '0'
			}, 250);
		}).on('mouseleave', function () {
			$(this).removeClass('is-open');
			$(this).find('.c-industry-selector__title').animate({
				top: '0'
			}, 250);
			$(this).find('.c-industry-selector__content').animate({
				top: '20px'
			}, 250);
		});
	});

	// Footer expand
	$('.js-advisory-trigger').removeAttr('href').click(() => {
		$('.js-advisory-target').toggleClass('is-open');
	});

	$('.form--infographic').prepend('<a href="#" id="ModalBackButton" class="c-modal__back-button">No Thanks</a>');

	$('#ModalBackButton').on('click', function (e) {
		e.preventDefault();
		// "No Thanks" is a hard-gate opt-out: leave the gated page rather than reveal it.
		// Only use history.back() when this tab actually has an in-site page to return to;
		// otherwise (direct arrival, shared link, new tab) it would unload/close the page.
		var sameSite = document.referrer.indexOf(window.location.origin) === 0;
		if (sameSite && window.history.length > 1) {
			window.history.back();
		} else {
			// Fall back to the infographics listing (parent of the current path; WPML-safe).
			window.location.href = window.location.pathname.replace(/[^/]+\/?$/, '');
		}
	});

	// Mobile header


	function addClassOnScroll() {
		if (window.innerWidth < 767) {
			var header = document.getElementById('site-header');
			var previousScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

			window.addEventListener('scroll', function () {
				var currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

				if (currentScrollPosition > previousScrollPosition) {
					// Scrolling down
					header.classList.add('js-hide');
				} else {
					// Scrolling up or at the top
					header.classList.remove('js-hide');
				}

				// Scrolling within 100px of top of page
				if (window.scrollY <= 100) {
					header.classList.remove('js-hide');
				}

				previousScrollPosition = currentScrollPosition;
			});
		}
	}

	// Execute on window load
	window.addEventListener('load', addClassOnScroll);

	// Execute on window resize
	window.addEventListener('resize', addClassOnScroll);



	// Remove select URLs from background image CSS generated from builder
	// or else they won't show on live site.

	// URLs
	var urlsToCheck = [
		'https://live-rapyd2024.pantheonsite.io/',
		'https://panth-live.rapyd.net/',
		'https://live-rapyd.pantheonsite.io/'
	];

	// Target only the builder's CSS output
	$('style[data-type="vc_shortcodes-custom-css"]').each(function() {
		var cssContent = $(this).html();

		urlsToCheck.forEach(function(url) {
			var regex = new RegExp(url, 'g');
			cssContent = cssContent.replace(regex, '/');
		});

		$(this).html(cssContent);
	});



}());
